export const API_BASE_URL = (() => {
  if (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) {
    return "https://swastik.orelse.ai";
  }
  return process.env.REACT_APP_API_URL || "https://swastik.orelse.ai";
})();

export const getAuthHeader = () => {
  const token = localStorage.getItem("swastik_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
